import { Component, OnInit } from '@angular/core';
import { SearchpostService } from '../../../services/searchpost.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public searchPostResult: any;

  constructor(private _SearchpostService: SearchpostService) { }

  ngOnInit() {
  }

  openSearch() {
    document.getElementById("myOverlay").style.display = "block";
  }

  closeSearch() {
    document.getElementById('myOverlay').style.display = 'none';
  }

  changeLang(lang: string) {
    switch (lang) {
      case 'pt': {
        localStorage.setItem('LOCAL_DEFAULT_LANGUAGE', 'pt');
        break;
      }
      case 'es': {
        localStorage.setItem('LOCAL_DEFAULT_LANGUAGE', 'es');
        break;
      }
      case 'en': {
        localStorage.setItem('LOCAL_DEFAULT_LANGUAGE', 'en');
        break;
      }
    }
  }

  getRoute(endpoint: string) {
    // const lang = localStorage.getItem('LOCAL_DEFAULT_LANGUAGE');
    return '/' + endpoint;
  }
  changeColor(pagename: string) {
    if (pagename === 'people') {
        document.getElementById('people').style.backgroundColor = 'red';
    }
  }

  searchPost(val) {
    this.searchPostResult = this._SearchpostService.searchPost(val.value);
    console.log('Data from service', this.searchPostResult);
  }

}
